import * as React from 'react';
import {
	BooleanField,
	DateField,
	EditButton,
	EmailField,
	Identifier,
	ImageField,
	Labeled,
	NumberField,
	Record,
	RecordMap,
	ReferenceField,
	TextField,
	UrlField
} from 'react-admin';
import { Card, CardContent, CardHeader } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useListStyles = makeStyles(theme => ({
	card: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		margin: '1.5rem 0',
		boxShadow: '0px 15px 20px #27313f0c !important',
		backgroundColor: 'white'
	},
	cardTitleContent: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between'
	},
	cardContent: theme.typography.body1,
	cardContentRow: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		margin: '0.5rem 0',
		fontWeight: 'bold'
	}
}));

interface TraineeListProps {
	ids?: Identifier[];
	data?: RecordMap<Record>;
	basePath?: string;
}

export const TraineeList = (props: TraineeListProps) => {
	const { ids, data, basePath } = props;
	const classes = useListStyles();

	if (!ids || !data || !basePath) {
		return null;
	}

	return (
		<div style={{ margin: '1em', backgroundColor: '#F8F9FC' }} className="list-container">
			{ids.map(id => (
				<Card key={id} className={classes.card}>
					<CardHeader
						title={
							<div className={classes.cardTitleContent}>
                                <span>
                                    {data[id].name}
                                </span>
								<EditButton
									resource="trainees"
									basePath={basePath}
									record={data[id]}
								/>
							</div>
						}
					/>
					<CardContent className={classes.cardContent}>
						<Labeled label="#" className={classes.cardContentRow}>
							<TextField record={data[id]} source="id" label="#"/>
						</Labeled>
						<Labeled label="FULL_NAME" className={classes.cardContentRow}>
							<TextField record={data[id]} source="fullName" label="FULL_NAME"/>
						</Labeled>
						<Labeled label="PHONE" className={classes.cardContentRow}>
							<TextField record={data[id]} source="user.phone.phone" label="PHONE"/>
						</Labeled>
						<Labeled label="EMAIL" className={classes.cardContentRow}>
							<EmailField record={data[id]} source="user.email" label="EMAIL"/>
						</Labeled>
						<Labeled label="PROFILE_IMAGE" className={classes.cardContentRow}>
							<ImageField record={data[id]} source="profileImageUrl" label="PROFILE_IMAGE"/>
						</Labeled>
						<Labeled label="MENU_PDF_URL" className={classes.cardContentRow}>
							<UrlField record={data[id]} source="menuPdfUrl" label="MENU_PDF_URL"/>
						</Labeled>
						<Labeled label="BIRTH_DATE" className={classes.cardContentRow}>
							<DateField record={data[id]} source="birthDate" label="BIRTH_DATE"/>
						</Labeled>
						<Labeled label="HEIGHT" className={classes.cardContentRow}>
							<NumberField record={data[id]} source="height" label="HEIGHT"/>
						</Labeled>
						<Labeled label="WEIGHT" className={classes.cardContentRow}>
							<NumberField record={data[id]} source="weight" label="WEIGHT"/>
						</Labeled>
						<Labeled label="COACH" className={classes.cardContentRow}>
							<ReferenceField record={data[id]} source="coachId" label="FORUM" reference="clients">
								<TextField source="fullName"/>
							</ReferenceField>

						</Labeled>
						<Labeled label="APPROVED_BY_COACH" className={classes.cardContentRow}>
							<BooleanField record={data[id]} source="approvedByCoach" label="APPROVED_BY_COACH"/>
						</Labeled>
						<Labeled label="ADDRESS" className={classes.cardContentRow}>
							<TextField record={data[id]} source="address.addressStr" label="ADDRESS"/>
						</Labeled>
						{/*<Labeled label="NOTE" className={classes.cardContentRow}>*/}
						{/*	<TextField record={data[id]} source="note" label="NOTE"/>*/}
						{/*</Labeled>*/}
					</CardContent>
				</Card>
			))}
		</div>
	);
};
